import React, { useState, useEffect, useRef } from 'react';
import api from '../../api';
import Swiper from '../swiper';
import PlatformWrapper from '../platform-wrapper';
import { RightOutlined } from '@ant-design/icons';
import './index.less';
import { env } from '@/env';
import { useSelector } from 'react-redux';
import ContentGroup from '@/pages/operate-platform/components/report-process/components/content-group';
import ReportEmpty from '@/pages/operate-platform/components/report-process/components/empty';
import TimeSelector from '@/pages/operate-platform/components/report-process/components/time-selector';
import { timeStatus } from '@/pages/operate-platform/components/report-process/constant';
import ComponentLog from '@/components/component-log';
import { Select, Tabs, Spin } from 'antd';
import goto from '@/common/goto';

const { Option } = Select;
const { TabPane } = Tabs;

function ReportProcess({ exposureLog = () => {} }) {
  // 最终渲染的数据
  const [data, setData] = useState([]);
  // 时间顺序
  const [status, setStatus] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  // 导航栏是否收起
  const collapsed = useSelector((state) => state.sideBar.collapsed);
  // 当前可渲染的卡片数
  const [cardNumber, setCardNumber] = useState(3);
  // 当前视口宽度
  const [clientW, setClientW] = useState(document.documentElement.clientWidth);
  const swiper = useRef();
  // 数据来源筛选 2：我创建的   1：我参与的
  const [source, setSource] = useState(1);

  const [activityList, setActivityList] = useState([]);

  const [selectActivity, setSelectActivity] = useState(undefined);

  const [activeKey, setActiveKey] = useState('2');

  // 处理数据
  const processData = (data, key) => {
    const result = [];
    for (let i = 0; i < data.length; i = i + key) {
      const group = [];
      for (let j = 0; j < key; j++) {
        // 数据不足，以''补足，方便渲染占位空卡片
        data[i + j] ? group.push(data[i + j]) : group.push('');
      }
      result.push(group);
    }
    return result;
  };

  // 获得当前页面可渲染卡片数
  const renderCardNum = (len) => {
    if (!len) return;
    const num = len / 300 > 2 ? Math.floor(len / 300) : 2;
    setCardNumber(num);
  };

  // 监听当前页面视口变化
  useEffect(() => {
    window.addEventListener('resize', function () {
      setClientW(document.documentElement.clientWidth);
    });
    return () => {
      window.removeEventListener('resize', function () {
        setClientW(document.documentElement.clientWidth);
      });
    };
  }, []);

  // 监听视口宽度以及导航栏的收起状态
  useEffect(() => {
    const barLength = collapsed ? 34 : 200;
    swiper.current && swiper.current.pageJump(0);
    renderCardNum(clientW - 498 - barLength);
  }, [clientW, collapsed]);

  // 筛选框数据
  useEffect(() => {
    setIsLoading(true);
    api
      .homeBizActivities({
        type: 2,
        currentPage: 1,
        pageSize: 100,
      })
      .then((res) => {
        if (res && res.ret === '0') {
          setIsLoading(false);
          setActivityList(res.data.list);
        } else {
          setIsLoading(false);
        }
      });
  }, []);

  // 请求数据
  useEffect(() => {
    setIsLoading(true);
    api
      .getVenueProcess({
        currentPage: 1,
        pageSize: 9,
        source: source,
        orderBy: timeStatus[status],
        planCode: selectActivity,
      })
      .then((res) => {
        if (res && res.ret === '0') {
          const result = processData(res.data.list, cardNumber);
          // 曝光埋点
          const { list = [] } = res.data;
          let ids = list.map((ele) => ele.id);
          exposureLog(ids.join(','));
          //---------------
          setIsLoading(false);
          setData(result);
        } else {
          setIsLoading(false);
        }
      });
    // eslint-disable-next-line
  }, [cardNumber, status, source, selectActivity]);

  // 当数据更新，重置swiper焦点位置
  useEffect(() => {
    swiper.current && swiper.current.pageJump(0);
  }, [data]);

  const resetDataSource = (val) => {
    if (val === source) return;
    setData([]);
    setSource(val);
  };

  const activityChange = (value) => {
    setSelectActivity(value);
  };

  const onTabChange = (activeKey) => {
    setActiveKey(activeKey);
  };

  return (
    <PlatformWrapper
      title="会场收品进度"
      background="#FFFFFF"
      id="step3"
      wrapperRight={
        <ComponentLog>
          <div className="report-process-name-filter" clstag="resource_1627030927203|42">
            <Select
              className="merchant-activity-select"
              placeholder="全部"
              size="small"
              onChange={activityChange}
              value={selectActivity}
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
            >
              <Option value={undefined} style={{ fontSize: 12 }}>
                全部
              </Option>
              {activityList.map((item, index) => (
                <Option value={item.planCode} key={index} style={{ fontSize: 12 }}>
                  {item.activityName}
                </Option>
              ))}
            </Select>
          </div>
        </ComponentLog>
      }
    >
      <Spin spinning={isLoading}>
        <div className="report-process-header-fixed-wrapper">
          <div className="report-process-header-wrapper">
            <TimeSelector status={status} setStatus={setStatus} />
          </div>
          <Tabs onChange={onTabChange} activeKey={activeKey}>
            <TabPane
              tab={
                <div
                  onClick={() => {
                    resetDataSource(1);
                  }}
                >
                  我参与的
                </div>
              }
              key="2"
            ></TabPane>
            <TabPane
              tab={
                <div
                  onClick={() => {
                    resetDataSource(2);
                  }}
                >
                  我管理的
                </div>
              }
              key="1"
            ></TabPane>
          </Tabs>
          {data && data.length > 0 ? (
            <>
              <Swiper len={data.length} height={261} isJump cls="hd_gallery_1606447516680|19" ref={swiper}>
                {data.map((item, index) => {
                  return <ContentGroup key={index} data={item} cardNumber={cardNumber} dataSource={source} />;
                })}
              </Swiper>
              <ComponentLog>
                <a
                  clstag="hd_gallery_1606447516680|17"
                  className="platform-more"
                  onClick={() => goto.toDataPanelRoomFlowDataList().push()}
                >
                  更多
                  <RightOutlined style={{ color: 'rgba(0, 0, 0, 0.65)' }} />
                </a>
              </ComponentLog>
            </>
          ) : (
            <ReportEmpty />
          )}
        </div>
      </Spin>
    </PlatformWrapper>
  );
}

export default ReportProcess;
